import React from "react";
import "../CSS/Services.css"

const Services = () => {
    return(
    <div>
    <h1>Services</h1>
    
    
    <img className='services-img' alt='' src={require('../Static/Collaboration.jpg')}></img>


        
    <div className="services-box">

        <p className="services-text">
        <div className="inner-services-text">
            
             Would you like to work with me? let's do it! 
        

            <h3>Technical Advisory</h3>
                

                Would you like to have an experienced Data/Software/AI professional to discuss and spar with?
                Let's do it! I love to contribute to exciting projects in many ways. I can help you out to decide and figure out what
                technologies to use and what competencies you would need in order to succeed with your project. I can even serve as a trainer/provisional team lead
                if the situation calls for it :)


            <h3>Tech strategizing</h3>

                Are you wondering about the whys, whats, whos and hows when it comes to contribution different technologies can have for your business?
                I have many years of experience helping managers and C-level executives shape and refine their tech-based business strategies.
                I take pride in being an eclectic and open problem solver, so don't expect any "written in stone" kind of views from my side when strategizing. 
                You can rest assured that we will solve your problems based on facts, knowledge and agreed-upon principles instead of personal preferences.


            <h3>Training</h3>


                Do you need someone to mentor you or perhaps mentor and/or train your team? I am glad to hear that!
                Teaching and mentoring is one of passions and I have been mentoring people in my fields of expertise (Data Science, Data Analytics, Data Engineering, Machine Learning Engineering and Software Engineering) for a long time now.
                I would love for us to explore together how exactly I can help you and/or your team upskill and get better at something you need to get better at.

            </div>
        </p>

        </div>


        </div>
    )

}

export default Services;


// WEBPACK FOOTER //
// ./src/Components/Services.js